/* Core & libraries */
import * as React from "react";
import { useTheme } from "react-jss";
import Skeleton from "react-loading-skeleton";

/* Helpers, constants, custom methods, internal libraries */

/* Components */

/* Styles */
import styles from "./styles.js";

const FareAccessTabSkeleton = () => {
  const theme = useTheme();
  const classes = styles({ theme });

  return (
    <div className={classes.skeletonWrapper}>
      <div className={classes.firstPart}>
        <div className={classes.firstRow}>
          <Skeleton count={1} width={150} className={classes.shortSk} />
          <Skeleton count={1} width={280} className={classes.shortSk} />
        </div>
        <div className={classes.secondRow}>
          <Skeleton count={1} width={280} className={classes.longSk} />
          <Skeleton count={1} width={280} className={classes.longSk} />
          <Skeleton count={1} width={280} className={classes.longSk} />
        </div>
      </div>
    </div>
  );
};

export default FareAccessTabSkeleton;
